import { AbstractControl, ValidationErrors } from "@angular/forms";

export function passwordValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null
  }
  if (control.value.trim().length !== 0) {
    return null;
  }
  return { 'notValidPassword': true }
}